



































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class SystemPassword extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  private passwordCurrent!: string;

  @Prop()
  private passwordNew!: string;

  @Prop({default: false})
  private valid!: boolean;

  private passwordRepeat: string = '';

  private passwordCurrentShow: boolean = false;
  private passwordNewShow: boolean = false;
  private passwordRepeatShow: boolean = false;

  private passwordRepeatRules = [this.required, this.matchNew.bind(this)];

  private required(value: string) {
    return !!value || 'Required';
  }

  private minLength(value: string) {
    return value.length >= 7 || 'Min 7 characters';
  }

  private matchNew(value: string) {
    return value === this.passwordNew || 'The passwords you entered don\'t match';
  }

  @Watch('valid')
  private onValidChanged() {
    this.$emit('update:valid', this.valid);
  }

}
